import { all } from "redux-saga/effects";
import { authSaga } from "./auth/authSaga";
import categorySagaWrapper from "./category/categorySagaWapper";
import { inBangDiemSaga } from "./in-bang-diem/inBangDiemSaga";
import tongHopDiemSagaWrapper from "./tong-hop-diem/tongHopDiemSagaWrapper";
import tongHopSagaWrapper from "./tong-hop/tongHopSagaWrapper";
import xetHocVuSagaWrapper from "./xet-hoc-vu/xetHocVuSagaWrapper";
import xetTotNghiepSagaWrapper from "./xet-tot-nghiep/xetTotNghiepSagaWrapper";
import xetChungChiSagaWrapper from "./xet-chung-chi/xetChungChiSagaWrapper";
import xetThucTapSagaWrapper from "./xet-thuc-tap/xetThucTapSagaWrapper";
import chuongTrinhDaoTaoSagaWrapper from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoSagaWrapper";
import chungChiChungNhanSagaWrapper from "./chung-chi-chung-nhan/chungChiChungNhanSagaWrapper";
import { bieuMauNguoiDungSaga } from "./quan-ly-bieu-mau/bieuMauNguoiDungSaga";
import { traCuuDiemSaga } from "./tra-cuu-diem/traCuuDiemSaga";
import { dashboardSaga } from "./dashboard/dashboardSaga";
import { xetKhoaLuanSagaWrapper } from "./xet-khoa-luan/xetKhoaLuanSagaWrapper";
import toChucThiSagaWrapper from "./to-chuc-thi/toChucThiSagaWrapper";
import { hocLaiThiLaiSaga } from "./hoc-lai-thi-lai/hocLaiThiLaiSaga";
import { tinhTrangNoMonSaga } from "./tinh-trang-no-mon/tinhTrangNoMonSaga";
import { hocPhanMienSaga } from "./hoc-phan-mien/hocPhanMienSaga";
import { quanLyNganh2SagaWrapper } from "./quan-ly-nganh-2/quanLyNganh2SagaWrapper";

export default function* rootSaga() {
    yield all([
    authSaga(),
    categorySagaWrapper(),
    inBangDiemSaga(),
    tongHopDiemSagaWrapper(),
    tongHopSagaWrapper(),
    xetHocVuSagaWrapper(),
    xetTotNghiepSagaWrapper(),
    xetChungChiSagaWrapper(),
    xetThucTapSagaWrapper(),
    chuongTrinhDaoTaoSagaWrapper(),
    chungChiChungNhanSagaWrapper(),
    bieuMauNguoiDungSaga(),
    traCuuDiemSaga(),
    dashboardSaga(),
    xetKhoaLuanSagaWrapper(),
    toChucThiSagaWrapper(),
    hocLaiThiLaiSaga(),
    tinhTrangNoMonSaga(),
    hocPhanMienSaga(),
    quanLyNganh2SagaWrapper(),
  ]);
}